import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="share"
export default class extends Controller {
  static targets = ["content", "template"]
  static values = {
    link: String,
  }

  share() {
    navigator.clipboard.writeText(this.linkValue)

    let baseContent = this.contentTarget.innerHTML
    this.contentTarget.innerHTML = this.templateTarget.innerHTML
    setTimeout(() => {
      this.contentTarget.innerHTML = baseContent
    }, 3000)
  }
}


